var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},[_c('div',{staticClass:"timeline-item"},_vm._l((_vm.total),function(page){return _c('h6',{key:page,class:{
        'timeline-five': _vm.total === 5,
        'timeline-four': _vm.total === 4,
        'timeline-three': _vm.total === 3,
        current: page === _vm.current_page,
        concluded: page < _vm.current_page,
      }},[_vm._v("\n      "+_vm._s(page)+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }